
import { useState, useRef } from 'react';
import ConfettiEffect from '@/components/ConfettiEffect';
import PhoneFrame from './PhoneFrame';

const PhoneMockup = () => {
  const [showConfetti, setShowConfetti] = useState(false);
  const [confettiOrigin, setConfettiOrigin] = useState({ x: 50, y: 50 });
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handlePhoneClick = (event: React.MouseEvent) => {
    // Get the clicked element
    const target = event.target as HTMLElement;
    const button = target.closest('button');
    
    if (button) {
      const buttonRect = button.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      
      // Calculate the center of the clicked button relative to the viewport
      const buttonCenterX = ((buttonRect.left + buttonRect.width / 2) / viewportWidth) * 100;
      const buttonCenterY = ((buttonRect.top + buttonRect.height / 2) / viewportHeight) * 100;
      
      setConfettiOrigin({ x: buttonCenterX, y: buttonCenterY });
      setShowConfetti(true);
    }
  };

  return (
    <>
      <div className="relative">
        <div className="relative mx-auto max-w-sm">
          {/* Floating Elements Around Phone */}
          <div className="absolute -top-10 -left-10 w-20 h-20 border-2 border-yellow-400/40 rounded-full animate-bounce-in delay-500"></div>
          <div className="absolute -bottom-10 -right-10 w-16 h-16 border-2 border-white/40 rounded-full animate-bounce-in delay-700"></div>
          <div className="absolute top-1/3 -right-16 w-12 h-12 bg-purple-300/30 rounded-lg rotate-45 animate-pulse-gentle"></div>
          
          {/* Phone Frame */}
          <PhoneFrame onButtonClick={handlePhoneClick} buttonRef={buttonRef} />
        </div>
      </div>

      {/* Confetti Effect */}
      <ConfettiEffect
        trigger={showConfetti}
        type="complete"
        origin={confettiOrigin}
        onComplete={() => setShowConfetti(false)}
      />
    </>
  );
};

export default PhoneMockup;
